<template>
  <div class="managers">
    <div class="content">
      <p class="page-title">{{ $route.name }}</p>
      <button @click="newManager()" class="btn fixed_btn">New Manager</button>
      <div class="card">
        <p class="title">Your Managers</p>
        <div class='table-holder'>

          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Department Access</th>
                <th>Location Access</th>
                <th>Page Permissions</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <template v-if='managers.length'>
                <template v-for="(item, i) in managers">
                  <tr :key="i" :class="{ grey: i % 2 }">
                    <td data-label="Title"> {{ item.name }} </td>
                    <td data-label="emails">{{ item.email }}</td>
                    <td data-label="departments" v-html="listToString(item.departments,'departments')"></td>
                    <td data-label="locations" v-html="listToString(item.locations,'locations')"></td>
                    <td data-label="locations" v-html="getPermissionsAsHTMLString(item.permissions)"></td>
                    <td data-label="Edit">
                      <img
                        @click="handleEdit(item)"
                        class="action clickable"
                        src="@/assets/img/edit.svg"
                      />
                    </td>
                  </tr>
                </template>
              </template>
              <template v-else>
                <tr>
                  <td>You have no managers</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <div class='pagination'>
          <div class='action prev' :class="{inactive: !pagination.previous_doc}" @click="moveToPage(0)">
            <img src="@/assets/img/dark_arr.svg">
            <img src="@/assets/img/dark_arr.svg">
          </div>
          <div class='action prev' :class="{inactive: !pagination.previous_doc}" @click="moveToPage(0)">
            <img src="@/assets/img/dark_arr.svg">
          </div>
          <!-- <div class="pages">
            <div class='action page active' >
              {{((pagination.current_page-1)*pagination.page_size)+1}}-{{pagination.current_page*pagination.page_size}} of {{usage[source+'s']}}
            </div>
          </div> -->
          <div class='action next' :class="{inactive: !pagination.next_doc}" @click="moveToPage(1)">
            <img src="@/assets/img/dark_arr.svg">
          </div>
          <div class='action next' :class="{inactive: !pagination.next_doc}"  @click="moveToPage()">
            <img src="@/assets/img/dark_arr.svg">
            <img src="@/assets/img/dark_arr.svg">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Register from "@/components/Register";
import firebase from "firebase";
import DashboardPages from "@/utilities/menu.js";
import { mapState } from 'vuex'
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const auth = fb.default.auth;

export default {
  name: "Managers",
  components: {
    register: Register,
  },
  data() {
    return {
      details: null,
      managers: [],
      source: "managers",
      pagination: {
        previous_doc: null,
        next_doc: null,
        page_size: 10,
        current_page: 1
      },
      managers: []
    };
  },
  computed:mapState([
    'departments',
    'locations'
  ]),
  created(){
    return this.moveToPage(0)
  },
  methods: {
    getPermissionsAsHTMLString(permissions){
      if(!permissions){
        return ''
      }
      return DashboardPages.filter(p => permissions[p.name]).map(p => p.display).join('<br/>')
    },
    listToString(arr,field){
      return arr.reduce((acc,curr) => { 
        if(this[field][curr]){
          return `${acc}<br/>${this[field][curr].name}`
        } else {
          return acc
        }
      },'').substring(5)
    },
    moveToPage(page){
      let pagination = this.pagination;
      let ref = db
        .collection("user")
        .doc(this.user_doc.id)
        .collection(this.source)
        if(this.filter_values){
          for (const key in this.filter_values) {
            if (this.filter_values.hasOwnProperty(key) && this.filter_values) {
              const element = this.filter_values[key];
              if(element){
                ref = ref.where(`${key}.id`,'==',element.id)
              }
            }
          }
        }
      if(page === -1){ //Previous Page
        ref = ref.limit(pagination.page_size).orderBy('name','desc').startAfter(pagination.previous_doc);
      } else if ( page === 1 ) {//Next Page
        ref = ref.limit(pagination.page_size).orderBy('name').startAfter(pagination.next_doc);
      } else if ( page === 0 ) {//First page
        ref = ref.limit(pagination.page_size).orderBy('name')
      } else {//Last page
        let total = this.usage[this.source+'s'];
        let last_full_page = Math.floor(total/pagination.page_size);
        let limit = total - (last_full_page*pagination.page_size);
        ref = ref.limit(limit || pagination.page_size).orderBy('name','desc')
      }

      ref.get().then(query => {
        let docs = query.docs;

        if(page === -1 || page === undefined){ // counting down
          docs.reverse()
        }
        if(query.size === 0 && page !==0 ){
          if(page === 1){
            this.pagination.next_doc = null;
          } else if(page === -1){
            this.pagination.previous_doc = null;
          }
        } else {
          let managers = docs.map(d => Object.assign({id:d.id},d.data()))
          this.pagination.previous_doc = docs[0]
          this.pagination.next_doc = docs[docs.length-1]
          if(page === 0){
            this.pagination.previous_doc = null;
            this.pagination.current_page = 1;
            if(query.size < pagination.page_size ){
              this.pagination.next_doc = null;
            }
          } else if(page === undefined) {
            let total = this.usage[this.source];
            let last_full_page = Math.ceil(total/pagination.page_size);
            this.pagination.next_doc = null;
            this.pagination.current_page = last_full_page;
          } else {
            this.pagination.current_page += page;
            if(query.size < pagination.page_size ){
              this.pagination[page === -1 ? 'previous_doc': 'next_doc'] = null
            }
          }
          this.managers = managers;
        }
        this.pagination = Object.assign({},this.pagination);
      })
      return true
    },
    handleEdit(item) {
      this.$router.push("manager/" + item.id);
    },
    newManager() {
      let id = db.collection("manager").doc().id;
      this.goTo("/manager/" + id);
    },
  },
};
</script>

<style lang="scss">
.stats {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .card {
    width: 49%;
    position: relative;
    padding-top: 70px;
    transition: box-shadow 0.3s;
    cursor: pointer;
    &:hover {
      box-shadow: 0 0 15px rgba(128, 128, 128, 0.8);
    }
    img {
      position: absolute;
      z-index: 0;
      opacity: 0.1;
      height: 80%;
      right: 10%;
      top: 50%;
      transform: translateY(-50%);
    }
    .stat {
      font-size: 80px;
      color: #49c6d4;
      font-weight: 500;
      margin: 0;
      span {
        display: block;
        font-size: 16px;
        color: #132628;
        font-weight: 500;
        margin-top: -10px;
      }
    }
  }
}
</style>
